
export const TEXTS = {
    confidentialDocument: "Sekretessbelagt dokument",
    errorFetchInvoice: "Hämta faktura misslyckades",
    fetchingInvoice: "Hämtar faktura...",
    noAccess: "Åtkomst nekad. Ditt konto saknar behörighet till Visa Faktura.",
    print: "Skriv ut",
    printError: "Det gick inte att skriva ut filen, vänligen kontakta " + 
            "systemutvecklare@akademiskahus.se om problemet kvarstår.",
    
  };
  